import React from 'react';
import { Row, Col } from 'reactstrap';

import { Card } from '../base/components/CardAccordion';
import DataStore from '../base/plumbing/DataStore';

import { PreviewLink } from './ExportControls';


/** 
 * Link the user to the "social splash video preview" section of the [local|test|prod] demo site.
 * TODO Modularise the splash video code from the demo page and integrate it directly here
 */
function SocialPreviewCard({ advert }) {
	// same options path as on the "publish" workflow step
	const path = ['widget', 'preview', 'optionParams'];
	const optionParams = DataStore.getValue(path) || {};

	return (
		<Card title="Preview Link"><Row><Col>
			The first thing a viewer sees on a social platform is a short "splash" video, inviting them to "swipe to donate".<br/>
			Swiping (or tapping, clicking, etc.) takes them to our adunit, where they can pick a charity, click through to the advertiser, or find out more about the campaign.<br/>			
			<PreviewLink advert={advert} params={optionParams} type="demo">
				See a mock-up
			</PreviewLink> of how the splash video might look on the demo site.
		</Col></Row></Card>
	);
}

export default SocialPreviewCard;
